// extracted by mini-css-extract-plugin
module.exports = {"read-more-trigger":"ArticlesReadMoreTrigger_read-more-trigger__GZxt0"};